import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import { kbdEvent } from "../utils/Utils";



export const searchBindings = (_search = "", callback = () => { }) => {

    pubCall("binding.getAll", {}, (_s, _r) => {

        callback(_s, _r);

    })

}

export default function Bindings(props) {

    const { controller = "", callback = () => { }, init_data = [], value = "", route = "" } = props;
    const [data, setData] = useState(init_data)
    const [selected, setSelected] = useState(init_data.find(item => item.binding === value) || {});



    const frontLoad = (rows = []) => {
        const common = ["HC", "MM", "PB", "TP", "BB", "OT"];
        return rows.map(item => ({ ...item, common: common.includes(item.binding) })).sort((a, b) => { const ai = common.indexOf(a.binding); const bi = common.indexOf(b.binding); if (ai === -1) return 1; if (bi === -1) return -1; return ai - bi; })
    };

    useEffect(() => {
        searchBindings(value, (_s, _r) => {
            if (_s) {
                _r = frontLoad(_r);
                let _f = _r.find(item => item.binding === value);
                if (_f) { setSelected(_f) } else {
                    let _f2 = _r.filter(item => item.binding.substr(0, 1) === value.substr(0,1))
                    if (_f2?.length) {
                        setSelected(_f2[0])
                    } else {
                        setSelected(_r[0])
                    }
                }
                setData(_r);
            } else {
                showError(_r);
            }
        })
    }, [])






    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(selected?.binding) } }
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions])


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const nextIndex = data.findIndex(item => item?.binding === selected?.binding) + _rows;
        if (data.length <= nextIndex) { setSelected(data[0]); }
        if (nextIndex < data.length) { setSelected(data[nextIndex]); }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.binding === selected?.binding) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return; }
        if (prevIndex >= 0) { setSelected(data[prevIndex]); }
    };

    const columns = [
        {
            key: "description", align: "left", title: <>Description</>, width: 228, grow: true, render: (e, f) => {
                return (f?.common) ? <span style={{ "color": "var(--text-yellow)" }}>{e.trim()}</span> : e.trim();
            }
        },
        {
            key: "binding", align: "left", title: <>Binding</>, width: 60, render: (e, f) => {
                return (f?.common) ? <span style={{ "color": "var(--text-yellow)" }}>{e}</span> : e;
            }
        },
    ]

    // return(<>{JSON.stringify(menu, null, 2)}</>)



    return (<>
        <Popup
            title={"Bindings"}
            width={"auto"}
            callback={callback}
            component={<VirtualTable
                controller={controller}
                row_key={"binding"}
                next={next}
                prev={prev}
                route={route}
                current={selected}
                rowClass={(e) => {
                    return (e?.binding === "OT") ? "ui-row-line" : ""
                }}
                data={data}
                width={300}
                height={388}
                offset={0}
                columns={columns}
                scrollbar={true}
                scrollindicator={true}
                onRowClick={(item, event, index) => { setSelected(item) }}
                onRowDoubleClick={(item, event, index) => { callback(item?.binding) }}

            />}
        />
    </>)
}